import './index.scss';

const Footer = () => (
  <footer>
    <div className="footer-inner">
      <span>© 2026 Jahan Shah</span>
      <span>jahan-shah.com · Kelowna, BC</span>
    </div>
  </footer>
);

export default Footer;
